import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-metric-card',
    templateUrl: './metric-card.component.html',
    styleUrls: ['./metric-card.component.scss']
})
export class MetricCardComponent {
    @Input() icon: string;
    @Input() title: string;
    @Input() value: string | number;
    @Input() subtitle?: string;
} 